module.exports = __webpack_public_path__ + "assets/df61fff27890e08a7c00e2b4a561e41f.png";